var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 107,
    viewBox: "0 0 201 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10279_65447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.408 2.24208C109.618 0.608357 102.571 0.324266 95.6712 1.40605C88.7709 2.48784 82.1521 4.91428 76.1932 8.54673C70.2341 12.1792 65.0517 16.9465 60.9418 22.5761C56.8321 28.2057 53.8756 34.5874 52.2412 41.3564L155.666 66.1993C158.967 52.5292 156.685 38.1119 149.324 26.118C141.962 14.1242 130.122 5.53591 116.408 2.24208Z",
    fill: "#657B8D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.409 2.24199C116.54 2.2249 116.672 2.2249 116.803 2.24199L117.939 2.54402C118.939 2.84606 120.454 3.1783 122.333 3.8579C127.751 5.82071 132.815 8.64064 137.333 12.2093C144.304 17.7111 149.766 24.8802 153.212 33.0501C157.682 43.5424 158.663 55.1856 156.015 66.2746L155.939 66.6219H155.576L103.863 54.2231L52.1512 41.764H51.8027L51.8936 41.4166C54.5732 30.3119 60.7611 20.3591 69.5452 13.0248C75.1568 8.33387 81.6809 4.84989 88.7079 2.79159C95.7347 0.733281 103.113 0.145123 110.378 1.06403C112.363 1.30566 113.863 1.71341 114.924 1.89463L116.075 2.13627C116.333 2.13627 116.469 2.22689 116.454 2.24199H116.06L114.894 2.04566C113.878 1.90974 112.378 1.54729 110.348 1.33586C104.659 0.714627 98.9064 0.989832 93.3027 2.15138C83.4852 4.21467 74.4532 9.00325 67.2494 15.9644C60.0456 22.9255 54.9638 31.7753 52.5906 41.4921L52.333 41.0542L104.045 53.4378L155.742 65.897L155.303 66.1689C157.647 56.449 157.185 46.2662 153.967 36.7976C150.749 27.3291 144.909 18.9617 137.121 12.6624C132.653 9.08835 127.653 6.22999 122.303 4.19016C120.454 3.48036 118.954 3.13301 117.969 2.78567L116.848 2.42322L116.409 2.24199Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.454 81.4919C197.671 68.1859 158.165 47.2829 106.215 34.8036C54.2644 22.3243 9.54225 22.9946 6.32496 36.3005C3.10769 49.6065 42.6137 70.5097 94.564 82.9889C146.514 95.4681 191.236 94.7978 194.454 81.4919Z",
    fill: "#657B8D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.97 81.7393C175.289 92.8544 137.94 93.4132 94.561 82.9928C51.1822 72.5723 18.1974 55.1144 20.8792 43.9993C23.561 32.8842 60.9096 32.3254 104.288 42.7458C147.667 53.1662 180.667 70.6393 177.97 81.7393Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.939 76.3779C130.772 81.1501 114.712 81.3918 96.0299 76.9065C77.348 72.4212 63.1661 64.9154 64.3327 60.1281C65.4994 55.3407 81.5602 55.1142 100.227 59.5995C118.893 64.0848 133.09 71.5905 131.939 76.3779Z",
    fill: "#657B8D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.745 76.3779C130.578 81.1502 114.517 81.3918 95.8355 76.9065C77.1537 72.4212 62.9717 64.9155 64.1384 60.1281C65.3051 55.3408 81.3658 55.1142 100.032 59.5995C118.699 64.0849 132.896 71.5906 131.745 76.3779Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.045 10.231C111.125 9.06983 110.744 7.92389 109.984 7.03982C109.225 6.15574 108.147 5.60423 106.984 5.50403C100.257 4.92417 93.4828 5.81274 87.1347 8.10791C80.7867 10.4031 75.0167 14.0497 70.2265 18.7938C64.9993 23.5661 90.0599 28.2477 105.075 29.9089C105.664 29.9692 106.259 29.9118 106.826 29.7401C107.392 29.5684 107.919 29.286 108.374 28.909C108.83 28.5322 109.206 28.0686 109.48 27.5453C109.753 27.0222 109.92 26.4497 109.969 25.8616C110.312 20.6464 110.671 15.4361 111.045 10.231Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10279_65447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 105.714,
    fill: "white",
    transform: "translate(0.5 0.642822)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.6886772c564dddb851dcba68aa5595d5.svg";
export { ForwardRef as ReactComponent };